import { z } from "zod"
import { RecordPaymentDtoSchema } from "@mimber/schema"

export const recordPaymentFormSchema = RecordPaymentDtoSchema.pick({
  amount: true,
  method: true,
  paidAt: true,
  note: true,
}).extend({
  paidAt: z
    .union([
      z.literal(""),
      z.string().datetime({ message: "Payment date must be a valid date" }),
    ])
    .optional()
    .transform((val) => (!val ? undefined : val)),
  note: z
    .string()
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
})

export type RecordPaymentFormData = z.infer<typeof recordPaymentFormSchema>
